import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardLayout from "../../components/utils/CardLayout";
import SearchBar from "../../components/utils/SearchBar";
import SideButtons from "../../components/utils/SideButtons";
import Table from "../../components/utils/Table";
import Modal from "../../components/utils/Model";
import Button from "../../components/utils/Button";
import { useForm, Controller } from "react-hook-form";
import planAction from "../../redux/plan/actions";
import PencilFill from "remixicon-react/PencilFillIcon";
import DeleteBin5Fill from "remixicon-react/DeleteBin5FillIcon";
import LinksLineIcon from "remixicon-react/LinksLineIcon";
import Popconfirm from "../../components/utils/Popover";
import { Link } from "react-router-dom";
import Tag from "../../components/utils/Tag";
import moment from "moment";
import CheckboxCircleFill from "remixicon-react/CheckboxCircleFillIcon";
import Alert from "../../components/utils/Alert";
import networkActions from "../../redux/network/actions";
import { isAdmin } from "../../helpers/commonFunction";
import authActions from "../../redux/auth/actions";
import Select from "react-select";
import AggregatorActions from "../../redux/aggregator/actions";
import shortCodeActions from "../../redux/shortCodeData/actions";

const { getShortCode } = shortCodeActions;

function Plan() {
  const dispatch = useDispatch();

  const { getActiveNetwork } = networkActions;
  const { getUserDataByToken } = authActions;

  const {
    addPlan,
    preparePlanForm,
    resetPlan,
    getPlan,
    resetPlanMessage,
    deletePlan,
    closePreferedAggregatorModalPlan,
    updatePreffedAggregatorPlan,
  } = planAction;

  const {
    planFormModal,
    deleteButtonLoading,
    planResult,
    planMessage,
    planError,
    planNameMessage,
    loading,
    planAggregatorError,
    planAggregatorMessage,
  } = useSelector((state) => state.plan);

  const buttonLoading = useSelector((state) => state.plan.buttonloading);

  const { networkResult } = useSelector((state) => state.network);

  const { shortCodeResult } = useSelector((state) => state.shortCode);

  const { tokenData } = useSelector((state) => state.auth);

  const { aggregatorListByNetworkIdForPlan } = useSelector(
    (state) => state.aggregator,
  );

  const { getAggregator, getAggregatorByNetworkIDForPlan } = AggregatorActions;

  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [filterText, setFilterText] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [formButton, setFormButton] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [planItemId, setPlanItemId] = useState();
  const [searched, setSearched] = useState(false);
  const [planRechargeId, setPlanRechargeId] = useState(0);
  const [networkId, setNetworkId] = useState(0);
  const [planFromData, setPlanFromData] = useState({
    name: "",
    planDesc: "",
    planPrice: "",
    networkID: "",
    multilineFlag: "0",
    pinValue: "",
    pinCount: "",
  });

  const [planSearchData, setplanSearchData] = useState({
    network: "",
  });

  const emptyData = {
    planID: "",
    name: "",
    planDesc: "",
    planPrice: "",
    networkID: "",
    multilineFlag: "0",
    pinValue: "",
    pinCount: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset: resetForm,
    control,
    setValue,
    resetField,
    clearErrors,
  } = useForm({
    defaultValues: planFromData,
  });

  const networkID = watch("networkID");

  // const planPriceWatch = watch("planPrice");

  const selectedNetwork = useMemo(() => {
    if (!networkID || !networkResult || networkResult.length === 0) {
      return null;
    }

    return networkResult.find(
      (network) => String(network.ID) === String(networkID),
    );
  }, [networkID, networkResult]);

  const isChatr = selectedNetwork?.NetworkName?.trim() === "Chatr";

  useEffect(() => {
    if (networkID) {
      dispatch(getAggregatorByNetworkIDForPlan(networkID));
    }
  }, [networkID]);

  useEffect(() => {
    if (!isChatr) {
      resetField("pinValue", {
        defaultValue: "",
      });

      resetField("pinCount", {
        defaultValue: "",
      });

      clearErrors(["pinValue", "pinCount"]);
    }
  }, [isChatr, resetField, clearErrors]);

  const {
    register: registerregister,
    handleSubmit: handleplanSubmit,
    formState: { errors: errorerror },
    control: searchControl,
    reset: resetSearchForm,
  } = useForm({
    defaultValues: planSearchData,
  });

  let columns = isAdmin(tokenData)
    ? [
        {
          displayName: "#",
          key: "key",
        },
        {
          displayName: "PLAN NAME",
          key: "planName",
        },
        {
          displayName: "PLAN PRICE",
          key: "planPrice",
        },
        ...(Number(networkId) === 1
          ? [
              {
                displayName: "PIN VALUE",
                key: "pinValue",
              },
              {
                displayName: "PIN COUNT",
                key: "pinCount",
              },
            ]
          : []),
        {
          displayName: "NETWORK",
          key: "network",
        },
        {
          displayName: "PLAN DESCRIPTION",
          key: "planDesc",
        },
        {
          displayName: "STATUS",
          key: "status",
        },
        {
          displayName: "ACTION",
          key: "action",
        },
      ]
    : [
        {
          displayName: "#",
          key: "key",
        },
        {
          displayName: "PLAN NAME",
          key: "planName",
        },
        // {
        //   displayName: "PLAN PRICE",
        //   key: "planPrice",
        // },
        // {
        //   displayName: "PIN VALUE",
        //   key: "pinValue",
        // },
        // {
        //   displayName: "PIN COUNT",
        //   key: "pinCount",
        // },
        {
          displayName: "NETWORK",
          key: "network",
        },
        {
          displayName: "PLAN DESCRIPTION",
          key: "planDesc",
        },
        {
          displayName: "STATUS",
          key: "status",
        },
      ];

  useEffect(() => {
    if (
      aggregatorListByNetworkIdForPlan &&
      aggregatorListByNetworkIdForPlan.length > 0
    ) {
      resetAggregatorData(aggregatorListByNetworkIdForPlan);
    }
  }, [aggregatorListByNetworkIdForPlan]);

  const resetAggregatorData = (aggregators) => {
    const defaultAggregatorData = aggregators.map((item) => ({
      aggregatorID: item.ID,
      key: item.AggregatorName,
      value: "",
    }));

    setValue("aggregatorData", defaultAggregatorData);
  };

  useEffect(() => {
    dispatch(getActiveNetwork());

    dispatch(getUserDataByToken());

    dispatch(
      getShortCode({
        tableName: "plan",
        fieldName: "PINValue",
      }),
    );
  }, []);

  useEffect(() => {
    resetForm(planFromData);
  }, [planFromData, resetForm]);

  useEffect(() => {
    if (planError !== null && planError !== undefined) {
      displayAlert(planError, "alert-danger");
    }

    if (planMessage !== null && planMessage !== undefined) {
      displayAlert(planMessage, "alert-success");
    }

    if (planAggregatorError !== null && planAggregatorError !== undefined) {
      displayAlert(planAggregatorError, "alert-danger");
    }

    if (planAggregatorMessage !== null && planAggregatorMessage !== undefined) {
      displayAlert(planAggregatorMessage, "alert-success");
    }

    if (planNameMessage !== null && planNameMessage !== undefined) {
      if (planNameMessage !== 0) {
        dispatch(resetPlanMessage());
      }
    }
  }, [
    planError,
    planMessage,
    planNameMessage,
    planAggregatorMessage,
    planAggregatorError,
  ]);

  const displayAlert = (text, type) => {
    setAlertText(text);

    setAlertType(type);

    setShowAlert(true);

    dispatch(resetPlanMessage());
  };

  const alertCancel = () => {
    setShowAlert(false);

    setAlertText("");

    setAlertType("");

    dispatch(resetPlanMessage());
  };

  const options = [
    ...(networkResult
      ?.filter((network) => network.ID)
      .map((network) => ({
        label: network.NetworkName,
        value: network.ID,
      })) || []),
  ];

  const filteredItems =
    Array.isArray(planResult) && planResult.length > 0
      ? planResult.filter((item) => {
          if (typeof filterText !== "string" || typeof item !== "object") {
            return false;
          }

          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(filterText.toLowerCase()),
          );
        })
      : [];

  const renderPlanTable = () => {
    if (searched) {
      return (
        <Table
          columns={columns}
          data={dataSource}
          loading={loading}
          pagination={true}
        />
      );
    }

    return null;
  };

  const dataSource =
    filteredItems &&
    filteredItems.length > 0 &&
    filteredItems.map((plan, key) => {
      let actionContent = isAdmin(tokenData) && (
        <>
          <Link to="#">
            <span data-toggle="tooltip" data-placement="top" title="Edit">
              <PencilFill
                size="1.2em"
                style={{
                  color: "#888b8e",
                  marginRight: "3px",
                }}
                onClick={() => handleOpenEditFormModal(plan.ID)}
              />
            </span>
          </Link>

          {deleteButtonLoading && planItemId === plan.ID ? (
            <span className="spinner-border spinner-border-sm" role="status" />
          ) : plan.IsActive === 1 ? (
            <Popconfirm
              title="Are you sure to inactive this plan?"
              okText="Yes"
              cancelText="No"
              placement="topRight"
              onConfirm={() => handleDelete(plan.ID, 0)}
            >
              <Link className="deleteBtn" to="# ">
                <span
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Inactive"
                >
                  <DeleteBin5Fill
                    size="1.2em"
                    style={{
                      color: "#f14336",
                      marginRight: "3px",
                    }}
                  />
                </span>
              </Link>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Are you sure to active this plan?"
              okText="Yes"
              cancelText="No"
              placement="topRight"
              onConfirm={() => handleDelete(plan.ID, 1)}
            >
              <Link className="deleteBtn" to="# ">
                <span data-toggle="tooltip" data-placement="top" title="Active">
                  <CheckboxCircleFill
                    size="1.2em"
                    style={{
                      color: "#2cb549",
                      marginRight: "3px",
                    }}
                  />
                </span>
              </Link>
            </Popconfirm>
          )}
        </>
      );

      return {
        key: key + 1,

        planName: plan.PlanName,

        ChildPrice: `$${plan.ChildPrice}`,

        planPrice: `$${Number(plan.PlanPrice).toFixed(2)}`,
        pinValue: `$${Number(plan.PINValue).toFixed(2)}`,
        pinCount: plan.PINCount,

        planDesc: (
          <span className="wrapped-text" title={plan.PlanDesc}>
            {plan.PlanDesc}
          </span>
        ),

        network: plan.NetworkName,

        createDate:
          plan.CreatedDtTm !== null
            ? moment(new Date(plan.CreatedDtTm)).format(
                `${process.env.REACT_APP_DATE_FORMAT}`,
              )
            : "N/A",

        status: (
          <Tag
            color={plan.IsActive === 1 ? "badge-success" : "badge-danger"}
            title={plan.IsActive === 1 ? "Active" : "Inactive"}
          />
        ),

        action: actionContent,
      };
    });

  const handleCancelModal = () => {
    dispatch(closePreferedAggregatorModalPlan());
  };

  const handleUpdatePrefferedAggregator = (data) => {
    data.PlanId = planRechargeId;

    dispatch(updatePreffedAggregatorPlan(data, networkId));
  };

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const handleOpenAddFormModal = () => {
    setEditFlag(false);
    const defaultNetwork = networkResult?.find(
      (item) => item.ID == 1 && item.IsActive == 1,
    );
    const resetData = {
      ...emptyData,
      networkID: "",
      pinValue: "",
      pinCount: "",
    };
    dispatch(preparePlanForm());
    setPlanFromData(resetData);
    resetForm(resetData);
    setFormButton("Submit");
    setFormTitle("Add Plan");
  };
  /*
   * Open Edit Modal
   */

  const handleOpenEditFormModal = (ID) => {
    dispatch(preparePlanForm());
    setFormTitle("Edit Plan");
    setFormButton("Update");
    setEditFlag(true);
    let selectedPlan = planResult.filter((plan) => plan.ID === ID);
    setPlanFromData((prevState) => ({
      ...prevState,
      planID: selectedPlan[0].ID,
      name: selectedPlan[0].PlanName,
      planPrice: selectedPlan[0].PlanPrice,
      planDesc: selectedPlan[0].PlanDesc,
      networkID: selectedPlan[0].NetworkID,
      multilineFlag: selectedPlan[0].MultilineFlag,
      pinValue: selectedPlan[0].PINValue,
      pinCount: selectedPlan[0].PINCount,
    }));
  };

  const handleUpdate = (data) => {
    data.networkId = networkId;
    dispatch(addPlan(data));
  };

  const onSubmit = (data) => {
    dispatch(addPlan(data));
  };

  const handleCancel = () => {
    setEditFlag(false);

    const resetData = {
      planID: "",
      name: "",
      planDesc: "",
      planPrice: "",
      networkID: "",
      multilineFlag: "0",
      pinValue: "",
      pinCount: "",
    };

    resetForm(resetData);

    setPlanFromData(resetData);

    resetField("pinValue", {
      defaultValue: "",
    });

    resetField("pinCount", {
      defaultValue: "",
    });

    clearErrors(["pinValue", "pinCount"]);

    resetAggregatorData([]);

    dispatch(resetPlan());
  };

  const handleDelete = (ID, flag) => {
    setPlanItemId(ID);

    dispatch(deletePlan(ID, flag));
  };

  const onPlanSubmit = (data) => {
    setSearched(true);

    setNetworkId(data.network.value);

    dispatch(getPlan(data.network.value));
  };
  return (
    <CardLayout title="Plan">
      {showAlert && (
        <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
      )}

      <form onSubmit={handleplanSubmit(onPlanSubmit)}>
        <div className="form-row planNetwork">
          <div className="col-lg-3 col-md-3">
            <label>Network</label>

            <Controller
              control={searchControl}
              name="network"
              {...registerregister("network", {
                required: true,
              })}
              render={({ field: { onChange, onBlur, value, name, ref } }) => (
                <Select
                  options={options}
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                  name={name}
                  ref={ref}
                />
              )}
            />

            {errorerror.network?.type === "required" && (
              <div className="invalid-feedback">Network required!</div>
            )}
          </div>

          <div className="networkSearchBtn">
            <Button
              title="Search"
              style="minWidth:80px"
              buttonClass="btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC"
              buttonType="submit"
            />
          </div>
        </div>
      </form>

      {searched ? (
        <div className="row align-items-baseline">
          <div className="col-lg-6 col-md-6 od-2">
            <SearchBar onFilter={handleFilterChange} filterText={filterText} />
          </div>

          <div className="col-lg-6 col-md-6 text-right">
            {isAdmin(tokenData) && (
              <SideButtons
                title="Add Plan"
                buttonStyle="primary"
                onClick={handleOpenAddFormModal}
              />
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {renderPlanTable()}

      <Modal
        showModal={planFormModal}
        title={formTitle}
        onHide={handleCancel}
        width={600}
        showFooter={false}
      >
        <form onSubmit={handleSubmit(editFlag ? handleUpdate : onSubmit)}>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label>
                Plan Name
                <span className="text-danger ms-1">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Plan Name"
                className="form-control"
                {...register("name", {
                  required: true,
                })}
              />

              {errors.name?.type === "required" && (
                <div className="invalid-feedback">Plan name is required !</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label>
                Plan Price
                <span className="text-danger ms-1">*</span>
              </label>

              <input
                type="number"
                step="any"
                className="form-control"
                placeholder="Enter Plan Price"
                onWheel={(e) => e.target.blur()}
                onKeyDown={(e) =>
                  ["ArrowUp", "ArrowDown"].includes(e.key) && e.preventDefault()
                }
                {...register("planPrice", {
                  required: true,
                })}
                disabled={editFlag ? true : false}
              />

              {errors.planPrice?.type === "required" && (
                <div className="invalid-feedback">Plan Price is required !</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label>
                Network
                <span className="text-danger ms-1">*</span>
              </label>

              <select
                className="form-control"
                {...register("networkID", {
                  required: "Network is required!",
                })}
                disabled={editFlag ? true : false}
              >
                <option value="">Select</option>

                {networkResult
                  ?.filter((item) => item.IsActive == 1)
                  .map((item) => (
                    <option value={item.ID} key={item.ID}>
                      {item.NetworkName}
                    </option>
                  ))}
              </select>

              {errors.networkID && (
                <div className="invalid-feedback">
                  {errors.networkID.message}
                </div>
              )}
            </div>

            {isChatr && (
              <>
                <div className="col-md-12">
                  <p
                    style={{
                      fontWeight: "600",
                      color: "#3f414d",
                      marginBottom: "5px",
                    }}
                  >
                    Chatr Configuration
                  </p>

                  <hr />
                </div>

                <div className="col-md-6 mb-3">
                  <label>
                    PIN Value<span className="text-danger ms-1">*</span>
                  </label>

                  <select
                    className="form-control"
                    {...register("pinValue", {
                      required: isChatr ? "PIN Value is required !" : false,
                    })}
                    disabled={editFlag ? true : false}
                  >
                    <option value="">Select PIN Value</option>

                    {shortCodeResult
                      ?.filter((item) => item.IsActive == 1)
                      .map((item) => (
                        <option key={item.ID} value={item.Value}>
                          ${item.Value}
                        </option>
                      ))}
                  </select>

                  {errors.pinValue && (
                    <div className="invalid-feedback d-block">
                      {errors.pinValue.message}
                    </div>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label>
                    PIN Count
                    <span className="text-danger ms-1">*</span>
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter pin count"
                    {...register("pinCount", {
                      required: isChatr ? "PIN is required !" : false,
                    })}
                    disabled={editFlag ? true : false}
                  />

                  {errors.pinCount && (
                    <div className="invalid-feedback">
                      {errors.pinCount.message}
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="col-md-12 mb-3">
              <label>
                Description
                <span className="text-danger ms-1">*</span>
              </label>

              <textarea
                className="form-control"
                placeholder="Enter Description"
                rows="3"
                {...register("planDesc", {
                  required: true,
                })}
              />

              {errors.planDesc?.type === "required" && (
                <div className="invalid-feedback">
                  Description is required !
                </div>
              )}
            </div>
          </div>

          <hr />

          <div className="text-right row">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={handleCancel}
              >
                Close
              </button>

              <Button
                title={formButton}
                style="minWidth:80px"
                buttonClass="btn btn-primary"
                loading={buttonLoading}
                buttonType="submit"
              />
            </div>
          </div>
        </form>
      </Modal>
    </CardLayout>
  );
}

export default Plan;
